import React from "react";
import {MenuItem} from "@material-ui/core";
import CdnPath from "../services/cdn_path";

export const getDateInLocalString = date => new Date(date).toLocaleDateString();
export const pickInitials = name => name.split(' ').splice(0, 2).map(word => word[0].toUpperCase()).join('');
export const itemTypeUrl = type => type && type !== 'other' ? CdnPath(`backend/icons/item_types/${type}.svg`) : '';
export const giaCertificate = gia_number => gia_number ? <a href={`https://www.gia.edu/report-check?reportno=${gia_number}`} target='_blank'>{gia_number}</a> : '';
export const bundleTypeInitials = type => type === 0 ? 'S' : 'JB';

// Analog for simple_format helper from rails
export const simpleFormat = str => {
  str = str.replace(/\r\n?/, "\n");
  str = $.trim(str);
  if (str.length > 0) {
    str = str.replace(/\n\n+/g, '</p><p>');
    str = str.replace(/\n/g, '<br />');
    // str = '<p>' + str + '</p>';
  }
  return str;
};

export const nextElem = (arr, i) => {
  i = i + 1; // increase i by one
  i = i % arr.length; // if we've gone too high, start from `0` again
  return arr[i]; // give us back the item of where we are now
};

export const  prevElem = (arr, i) => {
  if (i === 0) { // i would become 0
    i = arr.length; // so put it at the other end of the array
  }
  i = i - 1; // decrease by one
  return arr[i]; // give us back the item of where we are now
}

export const pushGAEvent = (category, action, lable) => {
  dataLayer.push({
      'event':'GTM event To GA',
      'GA_event_category':category,
      'GA_event_action': action,
      'GA_event_label': lable
  })
}

export const arrowKeysTrigger = (rightClass, leftClass) => {
  $("body").keydown(function(e) {
    if(e.which === 37) {
      $(leftClass).trigger("click");
    }
    else if(e.which === 39) {
      $(rightClass).trigger("click");
    }
  })
}

export const range = (start, end) => {
  /* generate a range : [start, start+1, ..., end-1, end] */
  let len = end - start + 1;
  let a = new Array(len);
  for (let i = 0; i < len; i++) a[i] = start + i;
  return a;
}

export const hourRange =
  range(0,23).map(hour => {
    hour = hour.toString().padStart(2, '0')
    return <MenuItem key={`row-${hour}`} value={hour}>{hour}</MenuItem>
  })
